<app-drawing-list
  *ngIf="hasDrawings()"
  [listOfDrawings]="listOfDrawings"
  [selectedDrawings]="selectedDrawings"
  [allowSelectMultipleDrawings]="allowSelectMultipleDrawings"
  (drawingSelected)="onDrawingSelected($event)"
  (virtualScrollerEnd)="onVirtualScrollerEnd()"
></app-drawing-list>

<vdw-nodata-overlay
  *ngIf="!hasDrawings() && !canShowProgressSpinner()"
  [shouldShowFilterNoResult]="hasFilterActive"
  titleParam="DESIGN_LIBRARY.DESIGN"
  [filterDescriptionParam]="{paramKeyCreate: 'DESIGN_LIBRARY.DESIGN'}"
>
</vdw-nodata-overlay>

<app-progress-spinner fxFlex fxLayoutAlign="center center" *ngIf="canShowProgressSpinner()" [text]="'GENERAL.LOADING.LOADING' | bmsTranslate"></app-progress-spinner>
